var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.processing
    ? _c(
        "div",
        { staticClass: "docuBlock" },
        [
          _c("SearchableDocumentsListCustom", {
            staticClass: "pb-5",
            attrs: {
              userFullName: _vm.contractorFullName,
              query: _vm.query,
              companyId: _vm.companyId,
              currentUser: _vm.currentUser,
              extraInfoHidden: "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "emptyListActions",
                  fn: function ({ refetchDocuments }) {
                    return [
                      _c("UploadDocumentResources", {
                        staticClass: "flex justify-end pt-3 pb-5",
                        attrs: {
                          attachedToUserId: _vm.contractorUserId,
                          companyId: _vm.companyId,
                          buttonLabel: "Upload document",
                          currentUserId: _vm.currentUser.id,
                          buttonSize: "xl",
                        },
                        on: {
                          documentaddSatrt: function ($event) {
                            _vm.processing = true
                          },
                          documentAdded: refetchDocuments,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "actions",
                  fn: function ({ refetchDocuments }) {
                    return [
                      _c("UploadDocumentResources", {
                        staticClass: "flex justify-end",
                        attrs: {
                          attachedToUserId: _vm.contractorUserId,
                          companyId: _vm.companyId,
                          buttonLabel: "Upload document",
                          currentUserId: _vm.currentUser.id,
                          currentUser: _vm.currentUser,
                        },
                        on: { documentAdded: refetchDocuments },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              1785774108
            ),
          }),
        ],
        1
      )
    : _c("div", [_c("p", [_vm._v("Loading...")])])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }